/*
* Script for scaling backgrounds
*
* Version: 1.0
*
* Author: Danny Hoek
*
* Contact: postduif@zwaarcontrast.nl
*
*/
(function($, window, document, undefined) {
	"use strict";

	//Constructor
	var FullSize = function(elem, options) {
		this.element = $(elem);
		this.$element = $(elem);
		this.options = options;
	};

	//Prototype
	FullSize.prototype = {

		defaults: {
		},

		//Initialisation
		init: function() {
			var _self = this;
			//Get the options and merge with defaults
			this.config = $.extend({}, this.defaults, this.options, this.metadata);
			this.lastOccurence = null;
			this.imageLoaded = false;
			this.element.addClass('is-container-sized');

			_self.bindLoadEvent();
			_self.getContainer();

			_self.bindRequestKeyframes();	
		},
		bindLoadEvent:function(){
			var _self = this;

			var placeholder = $('<img>');
			placeholder.one("load", function() {
				_self.imageLoaded = true;
			}).each(function() {
				if(this.complete) $(this).load();
			});
			placeholder.attr("src",_self.element.attr("src"));

			//Check if fullsize image is set for lazy loading
			if(this.element.attr('data-fullsize')){
				//Get large image url
				this.largeImg = this.element.data('fullsize');

				//Create placeholder
				var largePlaceholder = $('<img>');

				//Bind load and check for complete if already loaded
				largePlaceholder.one("load", function(){
					//Set new source and remove data attribute
					_self.element.attr("src", _self.largeImg).removeAttr('data-fullsize');
					_self.imageLoaded = true;
				}).each(function(){
					if(this.complete) $(this).load();
				})

				//Set source of large image to the placeholder
				largePlaceholder.attr("src",_self.largeImg);
			}
		},
		bindRequestKeyframes:function(){
			//Loop for Animation of the handler
			window.requestAnimFrame = (function(){
				return  window.requestAnimationFrame       ||
						window.webkitRequestAnimationFrame ||
						window.mozRequestAnimationFrame    ||
						window.oRequestAnimationFrame      ||
						window.msRequestAnimationFrame     ||
						function( callback ){
							window.setTimeout(callback, 1000 / 60);
						};
			})();

			var _self = this;
			(function animloop(){
				window.requestAnimFrame(animloop);
				_self.scale();
			})();
		},
		getContainer:function(){
			this.container = this.element.parent();
		},
		scale: function(){
			var _self = this;

			if(!this.ratio && this.imageLoaded){
				this.imageWidth = this.element[0].naturalWidth || this.element.attr('width');
				this.imageHeight = this.element[0].naturalHeight || this.element.attr('height');
				this.ratio = this.imageHeight / this.imageWidth;
			}
			
			// Get browser window size
			var containerWidth = this.container.width();

			// Get the parents size
			var containerHeight = this.container.height();

			// Scale the image (If load event did not fire yet, use temporary ratio of .75)
			if ((this.imageLoaded && (containerHeight/containerWidth) > this.ratio) || (!this.imageLoaded && (containerHeight/containerWidth) > 0.75)){
				this.element.css({'width':'auto','height':'100%'});
				this.lastOccurence = true;
			} else if((this.imageLoaded && (containerHeight/containerWidth) < this.ratio) || (!this.imageLoaded && (containerHeight/containerWidth) < 0.75)){
				this.element.css({'width':'100%','height':'auto'});
				this.lastOccurence = false;
			}
		}
	};
	$.fn.FullSize = function(options) {
		return this.each(function() {
			new FullSize(this, options).init();
		});
	};
})(jQuery, window, document);